/* Svensk katalog for locale-no.js (del 8 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'po.todaysPlanBase': 'Dagens plan — utgångspunkten',
  'po.editTodaysPlan': 'Redigera dagens plan',
  'po.netWealthToday': 'Nettoförmögenhet i dag',
  'po.monthlySavingShort': 'Månadssparande',
  'po.extraDebtRepayment': 'Extra amortering',
  'po.return': 'Avkastning',
  'po.retirementAge': 'Pensionsålder',
  'po.adjustAssumptions': 'Justera antaganden',
  'po.lifeEvents': 'Livshändelser',
  'po.lifeEventsSub': 'Planera stora händelser framåt — barn, bostad, föräldraledighet, sabbatsår — och se hur de formar hela framtidsbilden',
  'po.addEvent': 'Lägg till händelse',
  'po.lifeEventsHelp': 'Lägg in framtida händelser med startdatum, engångskostnad, månatlig effekt och varaktighet. Varje aktiv händelse läggs in vid rätt tidpunkt i prognosen. Stäng av en händelse för att se planen utan den. Händelserna sparas för valt år.',
  'po.effectOver5Years': 'Effekt på 5 år',
  'po.goalScore': 'Målpoäng',
  'po.goalScoreSub': 'Hur väl du ligger till för att nå dina mål — och vad som höjer poängen',
  'po.whatAffectsGoalScore': 'Detta påverkar målpoängen',
  'po.myRecommendationNow': 'Min rekommendation just nu',
  'po.prioritise': 'Prioritera',
  'po.talkAboutPlan': 'Prata med mig om planen',
  'po.yourGoals': 'Dina mål',
  'po.yourGoalsSub': 'Varje mål med återstående belopp, förväntat datum och sannolikhet',
  'po.newGoal': 'Nytt mål',
  'po.addGoal': 'Lägg till mål',
  'po.editGoal': 'Redigera mål',
  'po.deleteGoal': 'Ta bort mål',
  'po.remaining': 'Kvar',
  'po.expectedDone': 'Förväntat klart',
  'po.probability': 'Sannolikhet',
  'po.largestEffect': 'Störst effekt',
  'po.howReachFaster': 'Vad kan jag göra för att nå detta snabbare?',
  'po.nextMilestone': 'Nästa milstolpe',
  'po.nextMilestoneSub': 'Det du sannolikt uppnår först — i kronologisk ordning',
  'po.yourLifePlan': 'Din livsplan',
  'po.yourLifePlanSub': 'De viktigaste ekonomiska milstolparna framåt, byggda utifrån dina mål och din plan',
  'po.adjustLive': 'Justera antagandena — prognosen, målen och datumen uppdateras i realtid medan du drar.',
  'po.deleteGoalTitle': 'Ta bort målet?',
  'po.deleteGoalConfirm': 'Ta bort målet',
  'po.doYouWantToDelete': 'Vill du ta bort',
  'po.ownPartnerSharedSub': 'Översikt över egna, partnerns och gemensamma kostnader',
  'po.you': 'Du',
  'po.partner': 'Partner',
  'po.householdSpends': 'Hushållet spenderar',
  'po.reportSub': 'Visa, jämför, skriv ut och ladda ner månads- och årsrapporter',
  'po.print': 'Skriv ut',
  'po.downloadPdf': 'Ladda ner PDF',
  'po.pdfBusy': 'Skapar PDF …',
  'po.pdfFailed': 'Kunde inte skapa PDF av rapporten. Försök igen, eller använd Skriv ut.',
  'po.pdfFileName': 'privatekonomi-rapport',
  'po.compareWith': 'Jämför med',
  'po.compareHelp': 'Lägg en tidigare period bredvid för att se förändringen. ”Av” visar bara den valda perioden.',
  'po.ongoingPeriod': 'Pågående period — siffrorna är preliminära',
  'po.plummaSummary': 'SuperPlummas sammanfattning',
  'po.wentWell': 'Detta gick bra',
  'po.canImprove': 'Detta kan förbättras',
  'po.focusNextMonth': 'Fokus nästa månad:',
  'po.goDeeper': 'Vill du gå djupare? Fråga mig om rapporten.',
  'po.plummaNoticed': 'SuperPlumma lade märke till',
  'po.savingsRate': 'Sparkvot',
  'po.noImportedCosts': 'Inga importerade kostnader',
  'po.totalCosts': 'Summa kostnader',
  'po.whatHappensNext': 'Vad händer härnäst?',
  'po.setAsideOver12': 'Undanlagt på 12 mån',
  'po.averagePerMonth': 'Snitt per månad',
  'po.askWhatHappensNext': 'Fråga mig vad som händer härnäst',
  'po.whatFiguresMean': 'Vad siffrorna betyder',
  'po.youHaveStated': 'Du har angett att',
  'po.howItLooksAhead': 'Så här ser det ut framåt',
  'po.inSixMonths': 'Om 6 månader',
  'po.inTwelveMonths': 'Om 12 månader',
  'po.assetCategoryPh': 'T.ex. Fastighet',
  'po.assetsAndWealth': 'Tillgångar och förmögenhet',
  'po.assetsAndWealthSub': 'Allt du äger samlat — bostad, fordon, sparande och investeringar',
  'po.assetsHelp': 'Det sammanlagda värdet av det du äger, dina skulder och nettoförmögenheten (tillgångar minus skulder). ”Förväntad värdeförändring” summerar hur tillgångarna väntas stiga eller sjunka i värde under året.',
  'po.totalAssets': 'Sammanlagda tillgångar',
  'po.netWealth': 'Nettoförmögenhet',
  'po.expectedChangePerYear': 'Förväntad värdeförändring per år',
  'po.liquid': 'Likvid (sparande och fonder)',
  'po.assetCount': 'Antal tillgångar',
  'po.wealthHealth': 'Förmögenhetshälsa',
  'po.wealthHealthSub': 'Helhetsbedömning av hur robust din förmögenhet är — diversifiering, likviditet, risk och skuldsättningsgrad',
  'po.wealthStrongestOn': 'Din förmögenhet får högst poäng på',
  'po.wealthDistribution': 'Hur din förmögenhet är fördelad på kategorier',
  'po.expectedDevelopment': 'Förväntad utveckling',
  'po.expectedDevelopmentSub': 'Baserat på den värdeförändring du själv har angett per tillgång',
  'po.projectionHelp': 'Framskrivningen använder den förväntade årliga värdeförändring du har angett för varje tillgång. Plumme hämtar ännu inte in extern marknadsdata för bostad, begagnad bil eller fonder.',
  'po.withYourAssumptions': 'Med de antaganden du har angett förändras din förmögenhet med ungefär',
  'po.explainSimply': 'Förklara utvecklingen enkelt',
  'po.watchingClosely': 'Bevakas extra noga',
  'po.watchingCloselySub': 'Tillgångarna som väntas tappa i värde eller växa långsammare än inflationen',
  'po.explain': 'Förklara',
  'po.yourAssets': 'Dina tillgångar',
  'po.yourAssetsSub': 'Tryck på en tillgång för att redigera värde och detaljer',
  'po.addAsset': 'Lägg till tillgång',
  'po.askAboutTax': 'Fråga mig om skatten',
  'po.taxAssistant': 'Skattemelding-assistent',
  'po.taxAssistantSub': 'SuperPlumma guidar dig steg för steg och anpassar frågorna under tiden',
  'po.deductionHunter': 'Avdragsjägare',
  'po.deductionHunterSub': 'Avdragen sorteras efter förväntat värde — börja högst upp där vinsten är störst',
  'po.whyIThinkThis': 'Varför tycker jag så?',
  'po.dataIUsed': 'Data jag har använt',
  'po.whyYouQualify': 'Varför du har rätt till avdraget',
  'po.estimatedTaxBenefit': 'Uppskattad skattefördel',
  'po.taxOptimisation': 'Skatteoptimering',
  'po.taxOptimisationSub': 'Konkreta åtgärder sorterade efter frist — och vad de betyder för i år och nästa år',
  'po.nextYearOnwards': 'Nästa år och framåt',
  'po.aiTaxCheck': 'AI-skattekontroll',
  'po.aiTaxCheckSub': 'SuperPlumma går igenom dina importerade skatteuppgifter',
  'po.readyToFile': 'Redo för extern kontroll',
  'po.readyToFileSub': 'Jämför underlaget med skattemeldingen och årsbeskeden',
  'po.checkBasis': 'Kontrollunderlag',
  'po.requiresIntegration': 'Kräver officiell integration, stark autentisering och uttryckligt godkännande',
  'po.filingUnavailable': 'Inlämning inte tillgänglig',
  'po.whatIsMissing': 'Vad saknas före extern kontroll?',
  'po.whatRemains': 'Detta återstår',
  'po.taxBasisNotFetched': 'Skatteunderlaget har inte hämtats in',
  'po.alreadyVerified': 'Redan kvalitetssäkrat',
  'po.nothingVerified': 'Ingenting är kvalitetssäkrat ännu.',
  'spx.taxScheme': 'Skatte- och avgiftsordning',
  'spx.noItems': 'Inga poster registrerade ännu.',
  'spx.removeSpec': 'Ta bort specifikation',
  'prd.import': 'Importera produkter',
  'prd.excel': 'Excel (.xlsx)',
  'prd.export': 'Exportera produkter',
  'prd.csvName': 'Produkter CSV',
  'prd.excelName': 'Produkter Excel',
  'prd.countTemplateName': 'Mall för inventering',
  'prd.countTemplateEmpty': 'Inga varor att räkna. Inventeringsmallen tar med produkter av typen Vara.',
  'prd.countTemplateDone': 'Inventeringsmallen har laddats ner. Fyll i antal per 31.12. och kom ihåg att lagret värderas till inköpspris.',
  'prd.countTemplateError': 'Det gick inte att skapa inventeringsmallen.',
  'prd.colProductId': 'Produkt-ID',
  'prd.colInventoryAccount': 'Lagerkonto',
  'prd.colStockToday': 'Lagersaldo i dag',
  'prd.colCountedQuantity': 'Inventerat antal',
  'prd.colTotalCostValue': 'Totalt kostnadsvärde',
  'prd.colNote': 'Anmärkning',
  'prd.countSheetTitle': 'Inventering',
  'prd.countSheetIntro': 'Antal och varukostnad är förifyllda från dagens produktregister. Kontrollera och korrigera mot faktisk inventering på inventeringsdatumet.',
  'prd.countSheetDate': 'Inventeringsdatum',
  'prd.countSheetCountedBy': 'Inventerat av',
  'prd.countSheetReference': 'Referens',
  'prd.countSheetSignature': 'Signatur',
  'prd.countSheetNoteLabel': 'Obs',
  'prd.countSheetNote': 'Denna lista dokumenterar inventeringen. Redovisat värde och skattemässigt värde bedöms i bokslutet.',
  'prd.countSheetInfoTab': 'Information',
  'prd.countSheetWrongTemplate': 'Använd inventeringsmallen från Plumme. Kolumnerna stämmer inte.',
  'prd.countSheetOnlyXlsx': 'Automatisk inläsning stöder Excel-mallen (.xlsx). Andra filer sparas som dokumentation.',
  'prd.countSheetTabNotFound': 'Hittade inte bladet {name}.',
  'prd.countSheetRowError': 'Rad {row}: Kontrollera vara, lagerkonto, inventerat antal och varukostnad.',
  'prd.countSheetNoneCounted': 'Inga ifyllda antal hittades i inventeringslistan.',
  'prd.countSheetUnmappedAccount': 'Lagerkonto {account} kan inte fördelas automatiskt. Kontrollera kontona i genomgången.',
  'prd.filterHelp': 'Filtrera produkterna på typ (vara, tjänst, uthyrning), om de finns i lager och om borttagna ska visas.',
  'prd.listTitle': 'Produktlista',
  'prd.listSub': 'Varor och tjänster som du säljer',
  'prd.new': 'Ny produkt',
  'prd.searchPh': 'Sök på produktnamn, beskrivning, artikelnummer eller pris',
  'prd.searchHelp': 'Sök på produktnamn, beskrivning, artikelnummer eller pris.',
  'prd.none': 'Inga produkter här ännu',
  'prd.listHelpTitle': 'Produktlistan',
  'prd.listHelp': 'Varje rad är en produkt med artikelnr, pris, momssats, typ och lagersaldo. Tryck på en rad för att se detaljer och redigera.',
  'prd.detailsTitle': 'Produktdetaljer',
  'prd.detailsHelp': 'Beskrivning, artikelnummer, pris exkl. moms, momssats, typ och lagersaldo för produkten.',
  'prd.editHelp': 'Ändra namn, pris, moms, typ och lager för produkten.',
  'prd.delete': 'Ta bort produkt',
  'prd.deleteHelp': 'Flytta produkten till borttagna. Du kan återställa den senare.',
  'prd.itemNo': 'Artikelnr',
  'prd.colStockItem': 'Vara',
  'prd.stockReasonDefault': 'Fysisk inventering',
  'prd.stock': 'Lager',
  'prd.deleted': 'Borttagen',
  'prd.pickOwnColour': 'Välj egen färg',
  'prd.namePh': 'T.ex. Konsulttimme',
  'prd.priceExVat': 'Pris exkl. moms',
  'prd.price': 'Pris',
  'prd.priceIncVat': 'Pris inkl. moms',
  'prd.subscriptionPeriod': 'Abonnemangsperiod',
  'prd.multiDayDiscount': 'Flerdagsrabatt',
  'prd.multiDayHelp': 'Gäller bara denna uthyrningsprodukt.',
  'prd.day2ChargedAt': 'Dag 2 debiteras med',
  'prd.day3Onwards': 'Dag 3 och framåt',
  'prd.itemNumber': 'Artikelnummer',
  'prd.accountFallbackName': 'Konto',
  'prd.acct3000': 'Försäljning och uttag med momsplikt',
  'prd.acct3020': 'Försäljningsintäkt tjänster, hög momssats',
  'prd.acct3030': 'Försäljningsintäkt varor, mellersta momssats',
  'prd.acct3050': 'Försäljningsintäkt varor, låg momssats',
  'prd.acct3100': 'Försäljning och uttag med 0 procent moms',
  'prd.acct3200': 'Försäljning och uttag utanför mva-loven',
  'prd.acct3900': 'Övriga rörelseintäkter',
  'prd.colProductName': 'Produktnamn',
  'prd.colDescription': 'Beskrivning',
  'prd.colVat': 'Moms',
  'prd.colType': 'Typ',
  'prd.colRentalDiscount': 'Uthyrningsrabatt',
  'prd.colSalesAccount': 'Försäljningskonto',
  'prd.colEquivalentAccount': 'Motsvarar standardkonto',
  'prd.excelImportUnavailable': 'Excel-import är inte tillgänglig ännu.',
  'prd.excelExportUnavailable': 'Excel-export är inte tillgänglig ännu.',
  'prd.colStatus': 'Status',
  'prd.exportSheetName': 'Produkter',
  'prd.typeHeading': 'Rubrik',
  'prd.typeTextLine': 'Textrad',
  'prd.textLinesTitle': 'Textrader',
  'prd.newTextLine': 'Ny textrad',
  'prd.updateTextLine': 'Uppdatera textrad',
  'prd.saveTextLine': 'Spara textrad',
  'prd.textLineNamePh': 'T.ex. Standardtext för montering',
  'prd.textLineTextPh': 'Skriv texten som ska kunna användas på dokumentrader',
  'prd.styleFor': 'Stil för {target}',
  'prd.styleTargetText': 'Text',
  'prd.styleTargetName': 'Namn',
  'prd.styleBold': 'Fet',
  'prd.styleItalic': 'Kursiv',
  'prd.styleDivider': 'Avdelare',
  'prd.styleNoDivider': 'Utan avdelare',
  'prd.styleSummary': 'Namn: {name} · Text: {text} · {divider}',
  'prd.toastProductUpdated': 'Produkten har uppdaterats',
  'prd.toastProductSaved': 'Produkten har sparats',
  'prd.toastProductSaveError': 'Det gick inte att spara produkten.',
  'prd.toastProductDeleted': 'Produkten har tagits bort',
  'prd.toastProductDeleteError': 'Det gick inte att ta bort produkten.',
  'prd.toastTextLineUpdated': 'Textraden har uppdaterats',
  'prd.toastTextLineSaved': 'Textraden har sparats',
  'prd.toastTextLineSaveError': 'Det gick inte att spara textraden.',
  'prd.toastTextLineDeleted': 'Textraden har tagits bort',
  'prd.toastTextLineDeleteError': 'Det gick inte att ta bort textraden.',
  'prd.toastImportNoneFound': 'Hittade inga produkter i filen.',
  'prd.toastImportSuccess': '{count} produkter importerade',
  'prd.toastImportError': 'Det gick inte att importera produkter.',
  'prd.toastExportNone': 'Inga produkter att exportera',
  'prd.toastExportDone': 'Produktlistan har laddats ner',
  'prd.toastExportError': 'Det gick inte att exportera produktlistan.',
  'prd.textLineFilterHelp': 'Filtrera sparade textrader och rubriker.',
  'prd.filterOther': 'Annat',
  'prd.showDeleted': 'Visa borttagna',
  'prd.typeGoods': 'Vara',
  'prd.typeService': 'Tjänst',
  'prd.typeRental': 'Uthyrning',
  'prd.typeSubscription': 'Abonnemang',
  'prd.stockOnly': 'Endast i lager',
  'prd.textLineSubtitle': 'Sparade texter och rubriker för försäljningsdokument',
  'prd.titleHelp': 'Dina produkter — varor och tjänster som du säljer, med pris, moms och lager. Tryck på en produkt för detaljer.',
  'prd.uploadHelp': 'Importera produkter från en fil.',
  'prd.downloadHelp': 'Ladda ner produktlistan som CSV eller Excel.',
  'prd.addHelp': 'Lägg till en ny vara, tjänst, ett abonnemang eller en uthyrningsprodukt.',
  'prd.textLineSearchPh': 'Sök på namn, text eller typ',
  'prd.textLineSearchHelp': 'Sök i sparade textrader och rubriker.',
  'prd.emptyText': 'Lägg till varor och tjänster som du säljer, så går faktureringen blixtsnabbt.',
  'prd.textLineEmptyTitle': 'Inga textrader ännu',
  'prd.textLineEmptyText': 'Spara fasta texter, rubriker och produkttexter utan pris.',
  'prd.colBalance': 'Lagersaldo',
  'prd.colCostPerUnit': 'Varukostnad per enhet',
  'prd.colTotalValue': 'Totalt värde',
  'prd.colStockAvailable': 'Lager/tillgängligt',
  'prd.noneShort': 'Inga',
  'prd.subscriptionLabel': 'Abonnemang · {period}',
  'prd.month1Short': '1 mån',
  'prd.months12Short': '12 mån',
  'prd.copyToTextLine': 'Kopiera till textrad',
  'prd.colProduct': 'Produkt',
  'prd.colPrice': 'Pris',
  'prd.colName': 'Namn',
  'prd.colStyle': 'Stil',
  'prd.errNrTaken': 'Artikelnumret ”{nr}” används redan.',
  'prd.errAccountCodeFormat': 'Använd ett intäktskonto som börjar på 3 och har 4 eller 5 siffror.',
  'prd.errAccountNameRequired': 'Ge kontot ett namn.',
  'prd.errAccountEquivalentRequired': 'Välj det standardkonto som detta ska motsvara.',
  'prd.errAccountExists': 'Konto {code} finns redan.',
  'prd.errCostPriceInvalid': 'Kostpriset måste vara ett giltigt belopp på minst 0.',
  'prd.errTrackingDateRequired': 'Välj det datum då automatisk lagerstyrning ska starta.',
  'prd.errStockNegative': 'Ingående lagersaldo kan inte vara negativt.',
  'prd.errCostPriceRequired': 'Ange kostpris för ingående lagersaldo.',
  'prd.errCostPriceNegative': 'Kostpriset kan inte vara negativt.',
  'prd.noName': 'Utan namn',
  'prd.updateProduct': 'Uppdatera produkt',
  'prd.saveProduct': 'Spara produkt',
  'prd.rentalQtyLabel': 'Antal tillgängliga för uthyrning',
  'prd.autoInventoryTitle': 'Automatiskt lager och varukostnad',
  'prd.autoInventoryHelp': 'Inköp ökar lagret. Bokförda försäljningar minskar lagret och bokför beräknad varukostnad enligt vägt genomsnitt.',
  'prd.calculatedStock': 'Beräknat lagersaldo',
  'prd.openingStock': 'Ingående lagersaldo',
  'prd.avgCostPrice': 'Genomsnittligt kostpris',
  'prd.costPerUnit': 'Kostpris per enhet',
  'prd.inventoryValueLine': 'Lagervärde: {value}',
  'prd.month1': '1 månad',
  'prd.months12': '12 månader',
  'prd.advancedTitle': 'Avancerade produktdata',
  'prd.advancedHelp': 'SKU, EAN/GTIN, produktgrupp och importdata.',
  'prd.noGroup': 'Ingen grupp',
  'prd.removeGroup': 'Ta bort produktgrupp',
  'prd.newGroupPh': 'Ny produktgrupp',
  'prd.brand': 'Varumärke',
  'prd.variantName': 'Variantnamn',
  'prd.supplierItemNumber': 'Leverantörens artikelnr',
  'prd.internalReference': 'Intern referens',
  'prd.tags': 'Taggar',
  'prd.tagsPh': 'T.ex. webbutik, reservdel, vinter',
  'prd.saveAsTextLineTitle': 'Spara även som textrad',
  'prd.saveAsTextLineHelp': 'Skapar en kopia utan pris för dokumentrader.',
  'prd.autoAccountLine': 'Automatiskt: {account}',
  'prd.accountTypeLabel': 'Kontotyp',
  'prd.selectAccount': 'Välj konto',
  'prd.customAccountOption': 'Anpassat',
  'prd.accountInLedger': 'Konto i bokföringen',
  'prd.accountNamePh': 'Vidarefakturering',
  'prd.equivalentForYearEnd': 'Motsvarar för årsredovisning/skatt',
  'prd.selectStandardAccount': 'Välj standardkonto',
  'sub.tabsHelp': 'Växla mellan abonnemang med återkommande fakturering och kundlistor för samlad fakturering eller e-post.',
  'sub.start': 'Start',
  'sub.end': 'Slut',
  'sub.endHelp': 'Lämna tomt för att fortsätta tills abonnemanget pausas eller tas bort.',
  'sub.internalComment': 'Intern kommentar',
  'sub.saveCustomers': 'Spara kunder',
  'sub.searchCustomers': 'Sök kunder',
  'sub.searchCustomersPh': 'Sök efter namn, e-post eller org.nr...',
  'sub.selectVisible': 'Välj synliga',
  'sub.deselectVisible': 'Avmarkera synliga',
  'sub.noCustomers': 'Inga kunder ännu',
  'sub.howToInvoice': 'Hur vill du fakturera?',
  'sub.manualFlowNote': 'Valet nedan startar ett manuellt fakturaflöde för abonnemanget.',
  'sub.sendInvoice': 'Skicka faktura',
  'sub.openDraftFilled': 'Öppna ett fakturautkast med abonnemanget ifyllt.',
  'sub.openBlankDraft': 'Öppna ett tomt fakturautkast med kundurvalet valt.',
  'sub.subject': 'Ämne',
  'sub.message': 'Meddelande',
  'sub.removeAllAttachments': 'Ta bort alla bilagor',
  'sub.addCustomers': 'Lägg till kunder',
  'sub.noInvoiceSent': 'Ingen faktura skickad',
  'sub.noEmailSent': 'Inget e-postmeddelande skickat',
  'sub.unknownCustomer': 'Okänd kund',
  'sub.customersCount': '{count} kunder',
  'sub.cpiAnnualSuffix': ' · KPI {rate} % årligen',
  'sub.actionMenuLabel': 'Åtgärd',
  'sub.nameRequiredSubscription': 'Ge abonnemanget ett namn',
  'sub.nameRequiredList': 'Ge listan ett namn',
  'sub.nameRequiredListError': 'Ge listan ett namn.',
  'sub.nameRequiredAgreementError': 'Ge avtalet ett namn.',
  'sub.editSubTitle': 'Redigera abonnemang',
  'sub.editListTitle': 'Redigera lista',
  'sub.newSubTitle': 'Nytt abonnemang',
  'sub.newListTitle': 'Ny lista',
  'sub.saveChanges': 'Spara ändringar',
  'sub.saveSubscription': 'Spara abonnemang',
  'sub.saveList': 'Spara lista',
  'sub.namePlaceholderSub': 'T.ex. Guldmedlemskap',
  'sub.namePlaceholderList': 'T.ex. Nyhetsbrev',
  'sub.nextInvoiceDateLabel': 'Nästa fakturadatum',
  'sub.cpiAdjustmentLabel': 'KPI-justering',
  'sub.cpiAdjustmentHelp': 'Årlig konsumentprisjustering av abonnemangspriset.',
  'sub.customerSavedToast': 'Kunden "{name}" har sparats',
  'sub.saveCustomerError': 'Det gick inte att spara kunden.',
  'sub.addCustomersTitle': 'Lägg till kunder · {name}',
  'sub.selectedCount': '{count} valda',
  'sub.addAsNewCustomer': 'Lägg till ”{name}” som ny kund',
  'sub.noContactInfo': 'Ingen kontaktinformation',
  'sub.addCustomersEmptyText': 'Lägg till kunder i kundregistret först, eller skriv ett namn för att skapa en ny kund.',
  'sub.sendInvoiceTitle': 'Skicka faktura · {name}',
  'sub.attachmentTooLarge': 'Bilagor får vara högst {max}.',
  'sub.fillSubject': 'Fyll i ämne.',
  'sub.writeMessage': 'Skriv ett meddelande.',
  'sub.sendEmailTitle': 'Skicka e-post · {name}',
  'sub.sending': 'Skickar...',
  'sub.sendEmailButton': 'Skicka e-post',
  'sub.readyCount': '{count} klara',
  'sub.attachmentsAddedCount': '{count} bilagor tillagda',
  'sub.addAttachment': 'Lägg till bilaga',
  'sub.emailSendNote': 'E-post skickas via backend. Du kan släppa filer var som helst i dialogen eller klistra in med Ctrl+V. Mottagare utan e-postadress loggas som inte skickade.',
  'sub.typeSubscription': 'Abonnemang',
  'sub.typeList': 'Lista',
  'sub.actionClose': 'Stäng',
  'sub.actionOpen': 'Öppna',
  'sub.edit': 'Redigera',
  'sub.emailLabel': 'E-post',
  'sub.resume': 'Återuppta',
  'sub.pause': 'Pausa',
  'sub.delete': 'Ta bort',
  'sub.tabCustomers': 'Kunder ({count})',
  'sub.tabInvoices': 'Fakturor ({count})',
  'sub.tabEmails': 'E-post ({count})',
  'sub.addCustomersToInvoiceText': 'Lägg till kunder för att fakturera dem.',
  'sub.removeMember': 'Ta bort',
});
